// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__O6VO5","textCont":"styles_textCont__r9zPc","btn":"styles_btn__WJut0"};